/** State. */
export const STATE_CODES = {
  ALASKA: 'AK',
  ALABAMA: 'AL',
  ARKANSAS: 'AR',
  AMERICAN_SAMOA: 'AS',
  ARIZONA: 'AZ',
  CALIFORNIA: 'CA',
  COLORADO: 'CO',
  CONNECTICUT: 'CT',
  WASHINGTON_DC: 'DC',
  DELAWARE: 'DE',
  FLORIDA: 'FL',
  GEORGIA: 'GA',
  GUAM: 'GU',
  HAWAII: 'HI',
  IOWA: 'IA',
  IDAHO: 'ID',
  ILLINOIS: 'IL',
  INDIANA: 'IN',
  KANSAS: 'KS',
  KENTUCKY: 'KY',
  LOUISIANA: 'LA',
  MASSACHUSETTS: 'MA',
  MARYLAND: 'MD',
  MAINE: 'ME',
  MARSHALL_ISLAND: 'MH',
  MICHIGAN: 'MI',
  MINNESOTA: 'MN',
  MISSOURI: 'MO',
  MISSISSIPPI: 'MS',
  MONTANA: 'MT',
  NORTH_CAROLINA: 'NC',
  NORTH_DAKOTA: 'ND',
  NEBRASKA: 'NE',
  NEW_HAMPSHIRE: 'NH',
  NEW_JERSEY: 'NJ',
  NEW_MEXICO: 'NM',
  NEVADA: 'NV',
  NEW_YORK: 'NY',
  OHIO: 'OH',
  OKLAHOMA: 'OK',
  OREGON: 'OR',
  PENNSYLVANIA: 'PA',
  PUERTO_RICO: 'PR',
  RHODE_ISLAND: 'RI',
  SOUTH_CAROLINA: 'SC',
  SOUTH_DAKOTA: 'SD',
  TENNESSEE: 'TN',
  TEXAS: 'TX',
  UTAH: 'UT',
  VIRGINIA: 'VA',
  VIRGIN_ISLANDS: 'VI',
  VERMONT: 'VT',
  WASHINGTON: 'WA',
  WISCONSIN: 'WI',
  WEST_VIRGINIA: 'WV',
  WYOMING: 'WY',
};

export const STATE_SLUGS = {
  [STATE_CODES.ALASKA]: 'alaska',
  [STATE_CODES.ALABAMA]: 'alabama',
  [STATE_CODES.ARKANSAS]: 'arkansas',
  [STATE_CODES.AMERICAN_SAMOA]: 'american-samoa',
  [STATE_CODES.ARIZONA]: 'arizona',
  [STATE_CODES.CALIFORNIA]: 'california',
  [STATE_CODES.COLORADO]: 'colorado',
  [STATE_CODES.CONNECTICUT]: 'connecticut',
  [STATE_CODES.WASHINGTON_DC]: 'washington-dc',
  [STATE_CODES.DELAWARE]: 'delaware',
  [STATE_CODES.FLORIDA]: 'florida',
  [STATE_CODES.GEORGIA]: 'georgia',
  [STATE_CODES.GUAM]: 'guam',
  [STATE_CODES.HAWAII]: 'hawaii',
  [STATE_CODES.IOWA]: 'iowa',
  [STATE_CODES.IDAHO]: 'idaho',
  [STATE_CODES.ILLINOIS]: 'illinois',
  [STATE_CODES.INDIANA]: 'indiana',
  [STATE_CODES.KANSAS]: 'kansas',
  [STATE_CODES.KENTUCKY]: 'kentucky',
  [STATE_CODES.LOUISIANA]: 'louisiana',
  [STATE_CODES.MASSACHUSETTS]: 'massachusetts',
  [STATE_CODES.MARYLAND]: 'maryland',
  [STATE_CODES.MAINE]: 'maine',
  [STATE_CODES.MARSHALL_ISLAND]: 'marshall-island',
  [STATE_CODES.MICHIGAN]: 'michigan',
  [STATE_CODES.MINNESOTA]: 'minnesota',
  [STATE_CODES.MISSOURI]: 'missouri',
  [STATE_CODES.MISSISSIPPI]: 'mississippi',
  [STATE_CODES.MONTANA]: 'montana',
  [STATE_CODES.NORTH_CAROLINA]: 'north-carolina',
  [STATE_CODES.NORTH_DAKOTA]: 'north-dakota',
  [STATE_CODES.NEBRASKA]: 'nebraska',
  [STATE_CODES.NEW_HAMPSHIRE]: 'new-hampshire',
  [STATE_CODES.NEW_JERSEY]: 'new-jersey',
  [STATE_CODES.NEW_MEXICO]: 'new-mexico',
  [STATE_CODES.NEVADA]: 'nevada',
  [STATE_CODES.NEW_YORK]: 'new-york',
  [STATE_CODES.OHIO]: 'ohio',
  [STATE_CODES.OKLAHOMA]: 'oklahoma',
  [STATE_CODES.OREGON]: 'oregon',
  [STATE_CODES.PENNSYLVANIA]: 'pennsylvania',
  [STATE_CODES.PUERTO_RICO]: 'puerto-rico',
  [STATE_CODES.RHODE_ISLAND]: 'rhode-island',
  [STATE_CODES.SOUTH_CAROLINA]: 'south-carolina',
  [STATE_CODES.SOUTH_DAKOTA]: 'south-dakota',
  [STATE_CODES.TENNESSEE]: 'tennessee',
  [STATE_CODES.TEXAS]: 'texas',
  [STATE_CODES.UTAH]: 'utah',
  [STATE_CODES.VIRGINIA]: 'virginia',
  [STATE_CODES.VIRGIN_ISLANDS]: 'virgin-islands',
  [STATE_CODES.VERMONT]: 'vermont',
  [STATE_CODES.WASHINGTON]: 'washington',
  [STATE_CODES.WISCONSIN]: 'wisconsin',
  [STATE_CODES.WEST_VIRGINIA]: 'west-virginia',
  [STATE_CODES.WYOMING]: 'wyoming',
};

export class State {
  constructor(data) {
    this.name = data.name;
    this.stateCode = data.stateCode;
    this.timeZone = data.timeZone;
  }
}
